import * as dayjs from 'dayjs';
import { noop } from 'angular';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';
import { ActivityEditorPanel, activityEditorPanelToken } from 'go-modules/activity-editor-panel/activity-editor-panel.service';
import { EventService } from '@go-modules/services/event/event.service';
import type { GoEvent } from '@go-modules/services/event/event.service';
import { filter } from 'rxjs/operators';
import { EVENT_NAMES } from '@go-modules/services/event/event-names.constants';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { Masquerade, masqueradeToken } from 'go-modules/masquerade/masquerade.service';
import {
	Component,
	ElementRef,
	EventEmitter,
	HostBinding,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { CONTENT_TYPES, LIBRARY_TYPES, MODES } from '@go-modules/components/library/library-collections-viewer/library-collection-viewer.constants';
import { mediaToken } from 'go-modules/models/media/media.factory';
import { rubricEditorModalToken } from 'go-modules/modals/rubric-editor/modal.factory';
import { mediaPreviewToken } from 'go-modules/modals/media-preview/modal.factory';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogComponent } from '@go-modules/components/dialogs/message-dialog/message-dialog.component';
import { ConfirmDialogComponent, ConfirmDialogData } from '@go-modules/components/dialogs/confirm-dialog/confirm-dialog.component';
import { LibraryService, ShareLibraryItemResponse } from '@go-modules/services/library/library.service';
import { NgxActivityService } from '@go-modules/services/activity/activity.service';
import { UADetect as UADetectClass, uaDetectToken } from 'go-modules/detect/ua-detect.service';
import { activityToken } from 'go-modules/models/activity/activity.factory';
import { orgWideRubricReportToken } from 'go-modules/csv-report/org-wide-rubric-report/org-wide-rubric-report.service';
import { ShareLibraryItemDialogComponent } from '@go-modules/components/dialogs/share-library-item-dialog/share-library-item-dialog.component';
import { InvalidEmailsErrorDialogComponent } from '@go-modules/components/dialogs/invalid-emails-error-dialog/invalid-emails-error-dialog.component';
import { Types } from '@go-modules/services/media/media-types';
import { NgxMediaService } from '@go-modules/services/media/media.service';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import { CollectionDestinationComponent, CollectionDestinationData } from '@go-modules/components/library/collection-destination/collection-destination.component';
import { DESTINATION_MODES } from '@go-modules/components/library/collection-destination/collection-destination.constants';
import { PreviewMarkerSetDialogComponent } from '@go-modules/components/dialogs/preview-marker-set-dialog/preview-marker-set-dialog.component';
import { MarkerSetDialogComponent } from '../../dialogs/marker-set-dialog/marker-set-dialog.component';
import {
	OptionalDatePickerDialogComponent
} from '@go-modules/components/dialogs/optional-date-picker-dialog/optional-date-picker-dialog.component';
import {
	ActivityInstructionsDialogComponent
} from '@go-modules/components/dialogs/activity-Instructions-dialog/activity-instructions-dialog.component';
import { LibraryCollectionItemCacheService } from '@go-modules/services/library-collection-item-cache/library-collection-item-cache.service';
import type { Activity } from '@go-modules/interfaces/activity';
import type {
	LibraryCollection,
	LibraryCollectionItem,
	LibraryCollectionItemActivity,
	LibraryCollectionItemsAndFolders
} from '@go-modules/interfaces/library/library-collection';
import type { ContentTypeType } from '@go-modules/interfaces/library/library-types';
import { LibraryTreeDataSource } from '@go-modules/components/library/library-tree-viewer/library-tree-datasource';
import { BehaviorSubject, finalize, map } from 'rxjs';
import { LibraryTreeNode, NodeType } from '@go-modules/components/library/library-tree-viewer/library-tree-node';
import { LibraryActivityPanelStateService } from '@go-modules/services/library/library-activity-panel-state.service';
import { NgxFeatureFlagService } from '@go-modules/services/feature-flag/feature-flag.service';
import { ActivityPreviewEditorDialogService } from '@go-modules/components/dialogs/activity-preview-editor/activity-preview-editor-dialog.service';
import type { ActivityPreviewEditorDialogCloseResult } from '@go-modules/components/dialogs/activity-preview-editor/activity-preview-editor-dialog.service';
import type { Task } from '@go-modules/interfaces/task';
import type { LibraryDialogContext } from '@go-modules/components/dialogs/library-dialog/library-dialog.component';

interface ActivityLibrarySaveResult extends Activity {
	modified_at?: string;
	parent_child_sync?: boolean;
	description?: string;
}

interface ActivityLibraryDialogDraft extends Activity {
	tasks?: Task[];
}

type TreeGridCellTarget = 'select' | 'name' | 'modified' | 'actions';

@Component({
	selector: 'ngx-collection-item-viewer, tr[ngxCollectionItemRow]',
	templateUrl: './collection-item-viewer.component.html',
	styleUrls: ['./collection-item-viewer.component.scss'],
	standalone: false
})
export class CollectionItemViewerComponent implements OnInit, OnDestroy {
	public media: any;
	@Input() public mode: string;
	public modes = MODES;
	@Output() public selectItem: EventEmitter<any> = new EventEmitter();
	public toggledItemEl: HTMLButtonElement;
	@Input() public collections: LibraryCollection[];
	@Input() public archiveCollection: LibraryCollection;
	@Input() public selectedCollection: LibraryCollection;
	@Input() public selectedContentType: ContentTypeType;
	@Output() public loadNewItems: EventEmitter<any> = new EventEmitter();
	@Input() public collectionItems: LibraryCollectionItemsAndFolders;
	@Input() public items: LibraryCollectionItem[];
	@Input() public multiSelect: boolean;
	@Output() public setSelectAllChecked: EventEmitter<boolean> = new EventEmitter();
	@Input() public expandedHeight: number;
	@Input() public currentlySelected: any;
	public itemInUse: boolean;
	@Input() public orgSettings: any;
	@Input() public context?: LibraryDialogContext | null;
	public displayMenuOptions = new BehaviorSubject(true);
	public selectedGroup;
	private eventSubscription: any;
	@Output() public setActivityPanelIsOpen: EventEmitter<boolean> = new EventEmitter();
	@Output() public updateItems: EventEmitter<any> = new EventEmitter();
	@Output() public setCurrentlySelected: EventEmitter<any> = new EventEmitter();
	public iconClass;
	public loadingDetailsForItem = new BehaviorSubject<string>(null);
	public isLoadingDetailsForItem = this.loadingDetailsForItem.pipe(map((data) => data === this.collectionItem.hash));

	@Input() public nodeLevel = 0;
	@Input() public node: LibraryTreeNode<typeof NodeType.Item>;
	@Input() public treeTableDetailView = false;
	@Input() public treeGridNameTabindex: number | null = null;
	@Input() public treeGridModifiedTabindex: number | null = null;
	@Input() public treeGridActionTabindex: number | null = null;
	@Input() public treeGridCheckboxTabindex: number | null = null;
	@Input() public treeGridSelectHeaderId: string | null = null;
	@Input() public treeGridNameHeaderId: string | null = null;
	@Input() public treeGridModifiedHeaderId: string | null = null;
	@Output() public treeGridFocus: EventEmitter<TreeGridCellTarget> = new EventEmitter();
	@Output() public treeGridKeydown: EventEmitter<{
		event: KeyboardEvent;
		target: TreeGridCellTarget;
	}> = new EventEmitter();

	@HostBinding('class.active')
	public get hostActiveClass (): boolean {
		return this.isTreeTableRowHost() && this.isActive();
	}

	@HostBinding('class.tree-table-row')
	public get hostTreeTableRowClass (): boolean {
		return this.isTreeTableRowHost();
	}

	@HostBinding('class.tree-table-detail-view')
	public get hostTreeTableDetailViewClass (): boolean {
		return this.treeTableDetailView;
	}

	public get collectionItem (): LibraryCollectionItem {
		return this.node.data;
	}

	constructor (
		private activityService: NgxActivityService,
		private dialog: MatDialog,
		private eventService: EventService,
		private libraryService: LibraryService,
		private mediaService: NgxMediaService,
		private modal: GoModalService,
		private ngxGoToastService: NgxGoToastService,
		private translate: TranslateService,
		private itemCacheService: LibraryCollectionItemCacheService,
		private elementRef: ElementRef,
		private libraryActivityPanelStateService: LibraryActivityPanelStateService,
		private featureFlag: NgxFeatureFlagService,
		private activityPreviewEditorDialog: ActivityPreviewEditorDialogService,
		@Inject(uaDetectToken) public UADetect: UADetectClass,
		@Inject(activityEditorPanelToken) private activityEditorPanel: ActivityEditorPanel,
		@Inject(activityToken) private activityModel,
		@Inject(masqueradeToken) private masquerade: Masquerade,
		@Inject(mediaPreviewToken) private mediaPreviewModal,
		@Inject(mediaToken) private MediaModel,
		@Inject(orgWideRubricReportToken) private orgWideRubricReportService,
		@Inject(rubricEditorModalToken) private rubricEditorModal,
		@Inject(selectedServiceToken) private selectedService: SelectedService,
		@Inject(userServiceToken) private userService: UserService,
		public dataSource: LibraryTreeDataSource
	) {}

	public ngOnInit (): void {
		if (this.dataSource.isItemExpanded(this.collectionItem.hash)) {
			const cachedItem = this.itemCacheService.getItem(this.collectionItem.hash);
			if (cachedItem != null) {
				this.updateRenderedItem(cachedItem);
			}
		}

		this.selectedGroup = this.getContextGroup() || this.getContextAccount();
		// Watch for pubnub changes on library media
		this.eventSubscription = this.eventService.events
			.pipe(filter((ev: GoEvent) => ev.name === EVENT_NAMES.MEDIA_SYNC))
			.subscribe((ev: GoEvent) => {
				const originalItem = this.collectionItem;
				const allowedItemTypes = [CONTENT_TYPES.MEDIA as string, CONTENT_TYPES.DOCUMENTS as string];

				if (!allowedItemTypes.includes(originalItem.collection_item_type)) {
					return;
				}

				const mediaId = originalItem.item_id;

				if (mediaId === Number(ev.data.media_id)) {
					originalItem.item = ev.data;
					originalItem.media_type = ev.data.media_type; // we need to do this since the media_type on originalItem is iniitally an empty string
					originalItem.filename = ev.data.filename; // we need to do this since the filename on originalItem doesn't initially have an extension

					this.resolveIconClass(originalItem);

					// If we are expanded already, handle the media we made for that
					if (this.media) {
						Object.assign(this.media, ev.data);
					}
				}
			});

		this.itemInUse = false;
		if (this.collectionItem.collection_item_type === CONTENT_TYPES.RUBRICS) {
			this.displayMenuOptions.next(false);
		}

		if (this.isItemExpanded()) {
			this.media = this.MediaModel.model(this.collectionItem.item);
		}

		this.resolveIconClass(this.collectionItem);
	}

	private getContextGroup (): any {
		return this.hasExplicitContextValue('group')
			? this.context?.group ?? null
			: this.selectedService.getGroup();
	}

	private getContextAccount (): any {
		return this.hasExplicitContextValue('account')
			? this.context?.account ?? null
			: this.selectedService.getAccount();
	}

	private getContextOrg (): any {
		return this.hasExplicitContextValue('org')
			? this.context?.org ?? null
			: this.selectedService.getOrg();
	}

	private getContextLicense (): any {
		return this.hasExplicitContextValue('license')
			? this.context?.license ?? null
			: this.selectedService.getLicense();
	}

	private hasExplicitContextValue (key: keyof LibraryDialogContext): boolean {
		return this.context != null && Object.prototype.hasOwnProperty.call(this.context, key);
	}

	public isItemExpanded (): boolean {
		return this.dataSource.isItemExpanded(this.collectionItem.hash);
	}

	public isTreeTableRowHost (): boolean {
		return this.elementRef.nativeElement.tagName === 'TR';
	}

	public emitTreeGridFocus (target: TreeGridCellTarget): void {
		if (!this.isTreeTableRowHost()) {
			return;
		}

		this.treeGridFocus.emit(target);
	}

	public emitTreeGridKeydown (event: KeyboardEvent, target: TreeGridCellTarget): void {
		if (!this.isTreeTableRowHost()) {
			return;
		}

		this.treeGridKeydown.emit({ event, target });
	}

	public ngOnDestroy (): void {
		this.eventSubscription?.unsubscribe();
	}

	public formatDate (date) {
		return dayjs(date).format('MMM D, YYYY');
	}

	public getMenuAriaLabel (): string {
		const itemName = this.collectionItem.name || this.translate.instant('common_untitled');
		return `${this.translate.instant('collection-item-menu')}, ${itemName}`;
	}

	public getTreeGridNameElementId (): string {
		return `library-tree-item-name-${this.collectionItem.hash}`;
	}

	public getTreeGridModifiedElementId (): string {
		return `library-tree-item-modified-${this.collectionItem.hash}`;
	}

	public getTreeGridNameLabelledBy (): string | null {
		if (this.treeGridNameHeaderId == null) {
			return null;
		}

		return `${this.treeGridNameHeaderId} ${this.getTreeGridNameElementId()}`;
	}

	public getTreeGridModifiedLabelledBy (): string | null {
		if (this.treeGridModifiedHeaderId == null) {
			return null;
		}

		return `${this.treeGridModifiedHeaderId} ${this.getTreeGridModifiedElementId()}`;
	}

	public getAriaLabel (item) {
		const filename = item.filename;

		let translationKey;
		//if no filename, assume youtube
		const mediaType = filename ?
			this.mediaService.determineMediaType(filename) :
			Types.VIDEO;
		switch(item.collection_item_type)
		{
			case CONTENT_TYPES.RUBRICS:
				translationKey = 'library-collections_content-label-rubric';
				break;
			case CONTENT_TYPES.MARKERS:
				translationKey = 'library-collections_content-label-markers';
				break;
			case CONTENT_TYPES.MEDIA:
				translationKey = mediaType === Types.VIDEO ? 'library-collections_content-label-video' :
					'library-collections_content-label-audio';
				break;
			case CONTENT_TYPES.DOCUMENTS:
				translationKey = mediaType === Types.DOCUMENT ? 'library-collections_content-label-document' :
					'library-collections_content-label-image';
				break;
			case CONTENT_TYPES.ACTIVITIES:
				translationKey = 'library-collections_content-label-activities';
				break;
		}
		return this.translate.instant(translationKey, {name: item.name, date: this.formatDate(item.modified_at)});
	}

	public resolveIconClass (item) {
		const filename = item.filename;

		//if no filename, assume youtube
		const mediaType = filename ?
			this.mediaService.determineMediaType(filename) :
			Types.VIDEO;
		switch(item.collection_item_type)
		{
			case CONTENT_TYPES.RUBRICS:
				this.iconClass = 'ficon-rubric-filled';
				break;
			case CONTENT_TYPES.MARKERS:
				this.iconClass = 'ficon-app-tag-multiple';
				break;
			case CONTENT_TYPES.MEDIA:
				// Trust mediaType over filename (as thats more accurate until encoding is done)
				const itemMediaType = item.media_type;
				if (itemMediaType === Types.AUDIO) {
					this.iconClass = 'ficon-app-volume-medium';
				} else if (itemMediaType === '') {
					this.iconClass = 'ficon-spinner';
				} else {
					this.iconClass = mediaType === Types.VIDEO ? 'ficon-app-camcorder' : 'ficon-app-volume-medium';
				}
				break;
			case CONTENT_TYPES.DOCUMENTS:
				this.iconClass = mediaType === Types.DOCUMENT ? 'ficon-document-filled' : 'ficon-image-filled';
				break;
			case CONTENT_TYPES.ACTIVITIES:
				this.iconClass = this.isParentChildSync(item) ? 'ficon-activity-locked' : 'ficon-assignment';
				break;
		}
	}

	public loadRubricUsage (rubricItem) {
		this.libraryService.getRubricItemUsage(
			rubricItem.item.id, this.getContextOrg().group_id
		).subscribe((result: any) => {
			this.displayMenuOptions.next(true);
			this.itemInUse = result.in_use;
		});
	}

	public expandItem (item: LibraryCollectionItem): void {
		this.dataSource.toggleItem(item.hash);
		this.scrollIntoViewIfNeeded();

		this.media = this.MediaModel.model(item.item);
		const folderId = item.library_collection_folder_id;
		this.setCurrentlySelected.emit({ hash: item.hash, folderId });
	}

	private scrollIntoViewIfNeeded () {
		setTimeout(() => {
			const expandedItem = this.elementRef.nativeElement;
			const expandedItemRect = expandedItem.getBoundingClientRect();
			const scrollContainer = document.querySelector('.collection-items-list') as HTMLElement;
			const scrollContainerRect = scrollContainer.getBoundingClientRect();
			if (expandedItemRect.bottom > scrollContainerRect.bottom) {
				expandedItem.scrollIntoView({
					behavior: 'smooth',
					block: 'end'
				});
			}
		});
	}

	public showPreviewButton (item) {
		return item.collection_item_type === CONTENT_TYPES.RUBRICS ||
			item.collection_item_type === CONTENT_TYPES.MARKERS ||
			(item.collection_item_type === CONTENT_TYPES.DOCUMENTS && this.mediaService.isPreviewable(item.item)) ||
			item.collection_item_type === CONTENT_TYPES.ACTIVITIES;
	}

	public previewItem (item) {
		if(item.collection_item_type === CONTENT_TYPES.RUBRICS){
			this.openRubric(item.item_id, 'live');
		} else if (item.collection_item_type === CONTENT_TYPES.DOCUMENTS ||
			item.collection_item_type === CONTENT_TYPES.MEDIA){
			this.openMediaPreviewModal(item, false);
		} else if (item.collection_item_type === CONTENT_TYPES.MARKERS) {
			PreviewMarkerSetDialogComponent.open(this.dialog, {data: {
				markerSet: item.item
			}});
		} else if (item.collection_item_type === CONTENT_TYPES.ACTIVITIES) {
			this.activityService.get(item.item_id).subscribe((activity) => {
				activity = this.activityModel.model(activity);

				this.modal.open(ActivityInstructionsDialogComponent, false, {
					data: {
						activity,
						group: this.selectedGroup
					}
				});
			});
		}
	}

	public openRubric (schemaId, mode) {
		return this.rubricEditorModal.open({
			modalData: {
				options: {
					schemaId,
					mode,
					postData: {
						//if we end up copying the rubric then save to same collection
						add_to_collection: this.selectedCollection.id
					}
				}
			}
		}).result;
	}

	public openMediaPreviewModal (item, edit) {
		const media = this.MediaModel.model(item.item);
		return this.mediaPreviewModal.open({
			modalData: {
				media,
				edit,
				allowDownload: true
			}
		});
	}

	public edit (collectionItem) {
		if (!this.canEdit(collectionItem)) {
			return MessageDialogComponent.open(this.dialog, {
				data: {
					title: this.translate.instant('library-collections_item_edit_error-title'),
					message: this.translate.instant('library-collections_item_edit_error-message')
				}
			}).afterClosed().subscribe(() => {
				this.toggledItemEl.focus();
			});
		}

		if (collectionItem.collection_item_type === CONTENT_TYPES.MEDIA ||
			collectionItem.collection_item_type === CONTENT_TYPES.DOCUMENTS) {
			const media = this.MediaModel.model(collectionItem.item);
			media.description = collectionItem.description;
			media.library_id = collectionItem.library_collection_ids[0];
			return this.mediaPreviewModal.open({
				modalData: {
					media,
					edit: true,
					allowDownload: true,
					groupId: this.selectedGroup.group_id
				}
			}).result
				.then((data) => {
					Object.assign(collectionItem.item, data);
					collectionItem.description = data.description;
					collectionItem.name = data.title;
					collectionItem.modified_at = data.modified_at;

					this.dataSource.updateItem(collectionItem.hash, collectionItem);
				})
				.catch(noop)
				.finally(() => {
					this.toggledItemEl?.focus();
				});
		} else if (collectionItem.collection_item_type === CONTENT_TYPES.MARKERS) {
			return this.modal.open(MarkerSetDialogComponent, false, {
				data: {
					markerSet: collectionItem.item
				}
			}).afterClosed().subscribe((res) => {
				if (!res.dismissed) {
					Object.assign(collectionItem.item, res);
					collectionItem.description = res.description;
					collectionItem.name = res.title;
					collectionItem.modified_at = res.modified_at;

					this.dataSource.updateItem(collectionItem.hash, collectionItem);
				}
				this.toggledItemEl?.focus();
			});
		} else if (collectionItem.collection_item_type === CONTENT_TYPES.RUBRICS) {
			this.libraryService.checkRubricUsage(collectionItem.item.id)
				.subscribe((response) => {
					if (response.in_use) {
						const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = this.dialog.open(
							ConfirmDialogComponent, {
								data: {
									title: this.translate.instant('modal-rubric-edit-copy_title'),
									message: this.translate.instant('modal-rubric-edit-copy_message'),
									confirmText: this.translate.instant('common_create-copy'),
									cancelText: this.translate.instant('common_cancel')
								} as ConfirmDialogData
							});

						return dialogRef.afterClosed().pipe(
							filter((confirm: boolean) => confirm)
						).subscribe(() => {
							//copy item and open rubric editor, allow skip if in select mode
							this.copyItem(collectionItem, true, this.mode === MODES.SELECT);
						});
					} else {
						return this.openRubric(collectionItem.item_id, 'edit')
							.then((data) => {
								Object.assign(collectionItem.item, data);
								collectionItem.name = data.title;
								collectionItem.description = data.desc;
								collectionItem.modified_at = data.modified_at;

								this.dataSource.updateItem(collectionItem.hash, collectionItem);
							})
							.catch(noop)
							.finally(() => {
								this.toggledItemEl?.focus();
							});
					}
				});
		} else if (collectionItem.collection_item_type === CONTENT_TYPES.ACTIVITIES) {
			if (this.featureFlag.isAvailable('ACTIVITY_PREVIEW_EDITOR_DIALOG')) {
				this.openActivityPreviewEditorDialogForEdit(collectionItem);
				return;
			}
			const headerOptions: any = {
				editMode: true,
				hideName: false
			};

			this.activityService.get(collectionItem.item.id).subscribe((activity) => {
				activity = this.activityModel.model(activity);
				this.libraryActivityPanelStateService.setIsOpen(true);
				this.setActivityPanelIsOpen.emit(true);
				activity.group_id = this.selectedGroup.group_id;

				const isOrgCollectionAndCanModifyItems =
					this.libraryService.isOrgCollectionAndCanModifyItems(this.selectedCollection);
				return this.activityEditorPanel.open({
					user: this.userService.currentUser,
					group: this.selectedGroup,
					activity,
					headerOptions,
					libraryMode: true,
					isOrgCollectionAndCanModifyItems,
					orgSettings: this.orgSettings,
					firstFocusSelector: '#activity-editor-name-input'
				}).result.then((newActivity) => {
					collectionItem.name = newActivity.name;
					collectionItem.modified_at = newActivity.modified_at;
					collectionItem.item.parent_child_sync = newActivity.parent_child_sync;
					this.dataSource.updateItem(collectionItem.hash, collectionItem);
				}).catch(noop)
					.finally(() => {
						this.libraryActivityPanelStateService.setIsOpen(false);
						this.setActivityPanelIsOpen.emit(false);
						this.toggledItemEl?.focus();
					});
			});
		}
	}

	private openActivityPreviewEditorDialogForEdit (libraryItem: LibraryCollectionItem): void {
		const libraryActivity = libraryItem.item as LibraryCollectionItemActivity;
		this.activityService.get(libraryActivity.id).subscribe((activity) => {
			activity = this.activityModel.model(activity);
			activity.group_id = this.selectedGroup.group_id;

			const isOrgCollectionAndCanModifyItems =
				this.libraryService.isOrgCollectionAndCanModifyItems(this.selectedCollection);

			this.activityPreviewEditorDialog.open({
				mode: 'edit',
				activityId: activity.activity_id,
				activityDraft: activity,
				tasks: (activity as ActivityLibraryDialogDraft).tasks,
				group: this.selectedGroup,
				account: this.getContextAccount(),
				org: this.getContextOrg(),
				license: this.getContextLicense(),
				environment: {
					name: 'library'
				},
				libraryContext: {
					addToCollection: this.selectedCollection.id,
					addToFolder: libraryItem.library_collection_folder_id ?? null,
					isOrgCollectionAndCanModifyItems,
					orgSettings: this.orgSettings
				}
			}).then((dialogRef) => {
				dialogRef.afterClosed().subscribe((result: ActivityPreviewEditorDialogCloseResult) => {
					if (result != null && !('dismissed' in result)) {
						this.applyActivityEditorResult(libraryItem, result.activity);
					}

					this.toggledItemEl?.focus();
				});
			});
		});
	}

	private applyActivityEditorResult (
		libraryItem: LibraryCollectionItem,
		activity: ActivityLibrarySaveResult
	): void {
		const libraryActivity = libraryItem.item as LibraryCollectionItemActivity | undefined;

		libraryItem.name = activity.name;
		libraryItem.modified_at = activity.modified_at ?? libraryItem.modified_at;
		libraryItem.description = activity.description ?? libraryItem.description;
		libraryItem.item = {
			...(libraryItem.item ?? {}),
			...activity,
			parent_child_sync: activity.parent_child_sync ?? libraryActivity?.parent_child_sync
		} as LibraryCollectionItem['item'];

		this.dataSource.updateItem(libraryItem.hash, libraryItem);
	}

	public canEdit (item) {
		const userIds = this.getUserIds();
		return this.libraryService.isOrgCollectionAndCanModifyItems(this.selectedCollection) ||
			(userIds.includes(item.created_by) &&
				this.selectedCollection.type !== LIBRARY_TYPES.ARCHIVE) ||
			(userIds.includes(this.selectedCollection.created_by) &&
				this.selectedCollection.type === LIBRARY_TYPES.SHARED);
	}

	public setActiveToggle ($event) {
		this.toggledItemEl = $event.currentTarget;
		if (!this.displayMenuOptions.value) {
			this.loadItemDetails('loadRubricUsage', this.collectionItem);
		}
		this.setCurrentlySelected.emit({
			hash: this.collectionItem.hash,
			folderId: this.collectionItem.library_collection_folder_id
		});
	}

	public isActive () {
		return this.currentlySelected != null && this.currentlySelected.hash === this.collectionItem.hash;
	}

	public copyItem (item, launchRubricEditor: boolean = false, allowSkip: boolean = false) {
		const destinationData: CollectionDestinationData = {
			collections: this.collections,
			selectedCollection: this.selectedCollection,
			contentType: item.collection_item_type,
			mode: DESTINATION_MODES.COPY,
			allowSkip
		};
		if (this.currentlySelected?.id) {
			destinationData.defaultFolderId = this.currentlySelected.id;
		} else if (this.currentlySelected && this.currentlySelected.hash && this.currentlySelected?.folderId) {
			destinationData.defaultFolderId = this.currentlySelected.folderId;
		}
		this.modal.open(CollectionDestinationComponent, false, {
			data: destinationData
		}).afterClosed().subscribe((res) => {
			if (res.dismissed) {
				if (res.hasFolderAdded) {
					if (res.collection.id === this.selectedCollection.id) {
						this.loadNewItems.emit({});
					}
				}
				return;
			}
			let {collection} = res;
			const {folder, autoSelect, skipCollection} = res;
			if (skipCollection) {
				collection = this.archiveCollection;
			}
			const items = [{
				collections: [{collection_id: collection.id} as any]
			}] as any[];

			if (folder?.id > 0) {
				items[0].collections[0].folder_id = folder.id;
			}

			// Handle items from archive that may not
			// have an actual collectionItem
			if (item.id) {
				items[0].itemId = item.id;
			} else {
				items[0].item = {
					item_id: item.item_id,
					item_type: item.collection_item_type
				};
			}

			this.libraryService.copyCollectionItem({
				items
			}).subscribe((copiedItems) => {
				if (launchRubricEditor) {
					this.openRubric(copiedItems.data[0].item_id, 'edit')
						.then((res) => {
							if (autoSelect) {
								this.selectItem.emit({item: {item: res}});
							} else {
								this.loadNewItems.emit({expandItem: {collection, folder, item: res}});
							}
						})
						.catch(noop);
					return;
				}

				if (this.selectedCollection.id === collection.id) {
					this.loadNewItems.emit({ collection, folder });
				} else {
					this.ngxGoToastService.createToast({
						type: GoToastStatusType.SUCCESS,
						message: 'library-collections_copied'
					});
				}
			});
		});
	}

	public moveItem (item) {
		const destinationData: CollectionDestinationData = {
			collections: this.collections,
			selectedCollection: this.selectedCollection,
			contentType: item.collection_item_type,
			mode: this.canRestore(item) ? DESTINATION_MODES.RESTORE : DESTINATION_MODES.MOVE,
			item
		};
		if (this.currentlySelected?.id) {
			destinationData.defaultFolderId = this.currentlySelected.id;
		} else if (this.currentlySelected && this.currentlySelected.hash && this.currentlySelected?.folderId) {
			destinationData.defaultFolderId = this.currentlySelected.folderId;
		}
		this.modal.open(CollectionDestinationComponent, false, {
			data: destinationData
		}).afterClosed().subscribe((res) => {
			if (res.dismissed) {
				if (res.hasFolderAdded) {
					if (res.collection.id === this.selectedCollection.id) {
						this.loadNewItems.emit({});
					}
				}
				return;
			}
			const {collection, folder} = res;
			const data = {
				new_library_collection_id: collection.id,
				new_library_collection_folder_id: folder?.id ?? null,
				items: [
					{
						library_collection_id: this.selectedCollection.id,
						library_collection_folder_id: item.library_collection_folder_id,
						library_collection_item_id: item.id
					}
				]
			};
			this.libraryService.moveCollectionItem(data)
				.subscribe({
					next: () => {
						const fromFolderId = item.library_collection_folder_id ?? null;
						const toFolderId = data.new_library_collection_folder_id ?? null;

						if (this.selectedCollection.id === collection.id) {
							this.dataSource.moveItem(item.id, fromFolderId, toFolderId);
						} else {
							this.loadNewItems.emit({});
							item.library_collection_folder_id = toFolderId;
						}

						this.itemCacheService.addItem(item);
					},
					error: () => {
						MessageDialogComponent.open(this.dialog, {
							data: {
								title: this.translate.instant('library-collections_item_move_error-title'),
								message: this.translate.instant('library-collections_item_move_error-message')
							}
						}).afterClosed().subscribe(() => {
							this.toggledItemEl.focus();
						});
					}
				});
		});
	}

	public shareItem (item) {
		this.modal.open(ShareLibraryItemDialogComponent, false, {
			data: {
				collection_id: item.library_collection_ids[0],
				item_id: item.id
			}
		}).afterClosed().subscribe((res: ShareLibraryItemResponse) => {
			if (!res) return;
			const filteredEmails = res.invalidUsers.filter((email) => email !== item.creator_email);
			if (filteredEmails.length > 0) {
				InvalidEmailsErrorDialogComponent.open(this.dialog, {data: {
					title: this.translate.instant('modal-share-library-item_share-fail_title'),
					message: this.translate.instant('modal-share-library-item_share-fail_message'),
					emails: filteredEmails
				}});
			} else {
				this.ngxGoToastService.createToast({
					type: GoToastStatusType.SUCCESS,
					message: 'modal-share-library-item_share-success'
				});
			}
		});
	}

	// Either they created the shared collection
	// or they created the item in the collection (with the exception of archive)
	// or any legacy items not in my history
	public canRemove (item) {
		if (this.libraryService.isOrgCollectionAndCanModifyItems(this.selectedCollection)) {
			return true;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.MANAGED) {
			return this.userService.currentUser.is_root_content;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.ARCHIVE) {
			return false;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.DIRECT_SHARE ||
			item.shared_to === this.userService.currentUser.user_id) {
			return true;
		}

		const userIds = this.getUserIds();
		if (item.legacy_id !== null) {
			return userIds.includes(this.selectedCollection.created_by);
		}
		return userIds.includes(item.created_by) ||
			(userIds.includes(this.selectedCollection.created_by) &&
				this.selectedCollection.type === LIBRARY_TYPES.SHARED);
	}

	public canRestore (item) {
		return !item.location && item.id !== null && this.selectedCollection.type === LIBRARY_TYPES.ARCHIVE;
	}

	public canMove (item) {
		if (this.libraryService.isOrgCollectionAndCanModifyItems(this.selectedCollection)) {
			return true;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.MANAGED) {
			return this.userService.currentUser.is_root_content;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.ARCHIVE) {
			return false;
		}
		if (this.selectedCollection.type === LIBRARY_TYPES.DIRECT_SHARE ||
			item.shared_to === this.userService.currentUser.user_id) {
			if (item.collection_item_type === CONTENT_TYPES.ACTIVITIES && this.isParentChildSync(item)) {
				return false;
			}
			return true;
		}

		const userIds = this.getUserIds();
		if (item.legacy_id !== null) {
			return userIds.includes(this.selectedCollection.created_by);
		}
		return userIds.includes(item.created_by) ||
			(userIds.includes(this.selectedCollection.created_by) &&
				this.selectedCollection.type === LIBRARY_TYPES.SHARED);
	}

	public canShare () {
		return this.orgSettings?.block_copied_assignment_editing === false &&
			this.selectedCollection.type !== LIBRARY_TYPES.ARCHIVE;
	}

	public removeItem (item) {
		let removePromise = Promise.resolve(null);
		let title = this.translate.instant('library-collections_remove-item');
		let message = this.translate.instant('library-collections_remove-message');

		if (item.collection_item_type === CONTENT_TYPES.ACTIVITIES &&
			this.isParentChildSync(item) &&
			this.selectedCollection.type === LIBRARY_TYPES.ORG
		) {
			removePromise = new Promise((resolve, _reject) => {
				this.activityService.getChildrenCount(item.item_id).subscribe({
					next: (res) => {
						if (res.activities > 0) {
							title = this.translate.instant('modal-activity-remove-master-warning_title');
							message = this.translate.instant('modal-activity-remove-master-warning_message', {
								folders: res.activities
							});
						}
						return resolve(null);
					},
					error: () => {
						title = this.translate.instant('modal-activity-remove-master-warning_title');
						message = this.translate.instant('modal-activity-remove-master-warning_message', {
							folders: ''
						});
						return resolve(null);
					}
				});
			});
		}

		removePromise.then(() => {
			const dialogRef: MatDialogRef<ConfirmDialogComponent, any> = ConfirmDialogComponent.open(this.dialog, {
				data: {
					title,
					message,
					confirmText: this.translate.instant('common_remove'),
					cancelText: this.translate.instant('common_cancel')
				} as ConfirmDialogData
			});

			dialogRef.afterClosed().pipe(
				filter((confirm: boolean) => confirm)
			).subscribe(() => {
				this.libraryService.removeCollectionItem(this.selectedCollection.id, [item])
					.subscribe(() => {
						this.dataSource.removeItemByHash(item.hash);
					});
			});
		});
	}

	public checkSelection (): void {
		this.setSelectAllChecked.emit(this.collectionItems.items.every((item) => item.checked));
	}

	public onCheckboxChange (checked: boolean): void {
		this.dataSource.updateItemChecked(this.node.data.hash, checked);

		const visibleItemNodes = this.dataSource.data.filter((node) => node.type === NodeType.Item);
		const allVisibleItemsChecked = visibleItemNodes.length > 0 &&
			visibleItemNodes.every((node) => node.key === this.node.key ? checked : node.checked);

		this.setSelectAllChecked.emit(allVisibleItemsChecked);
	}

	public shouldShowEdit () {
		if (this.selectedCollection.type === LIBRARY_TYPES.MANAGED) {
			return this.userService.currentUser.is_root_content;
		}
		return this.selectedCollection.type !== LIBRARY_TYPES.ARCHIVE;
	}

	public downloadItem (item) {
		this.MediaModel.download(item.item_id);
	}

	public async downloadReport (item) {
		OptionalDatePickerDialogComponent.open(this.dialog, {
			data: { submitText: 'common_download', title: 'rubric-report-date-picker_title' }
		}).afterClosed().subscribe(async (res)=> {
			if (!res || res.dismissed) return;

			try {
				await this.orgWideRubricReportService.execute(
					item.item_id, this.getContextOrg().group_id, res.start_date, res.end_date
				);
			} catch (error) {
				return MessageDialogComponent.open(this.dialog, {
					data: {
						title: this.translate.instant('rubric-report_download-failed-title'),
						message: this.translate.instant('rubric-report_download-failed-message')
					}
				}).afterClosed().subscribe(() => {
					this.toggledItemEl.focus();
				});
			}
		});
	}

	public shouldShowDownloadButton (item): boolean {
		// it seems that items without filenames are youtube videos therefore shouldn't be downloadable
		return [CONTENT_TYPES.MEDIA, CONTENT_TYPES.DOCUMENTS].includes(item.collection_item_type) &&
			!!item.filename;
	}

	public loadItemDetails (method: string, item: LibraryCollectionItem): void {
		let cachedItem = this.itemCacheService.getItem(item.hash);

		// If not in cache, check if nested item is already available (library history)
		if (cachedItem == null && item.item != null) {
			this.itemCacheService.addItem(item);
			cachedItem = item;
		}

		if (cachedItem) {
			this.updateRenderedItem(cachedItem as LibraryCollectionItem);

			if (method === 'expandItem') {
				this[method](cachedItem);
			} else {
				this[method](cachedItem);
			}
		} else {
			this.loadingDetailsForItem.next(item.hash);
			this.dataSource.setItemDetailsLoading?.(item.hash, true);

			this.libraryService.getCollectionItemDetails(item.id).pipe(
				finalize(() => {
					this.loadingDetailsForItem.next(null);
					this.dataSource.setItemDetailsLoading?.(item.hash, false);
				})
			)
				.subscribe({
					next: (res) => {
						const itemWithDetails = {...item, ...res};
						this.updateRenderedItem(itemWithDetails);
						this.itemCacheService.addItem(itemWithDetails);

						if (method === 'expandItem') {
							this[method](itemWithDetails);
						} else {
							this[method](itemWithDetails);
						}
					},
					error: () => {}
				});
		}
	}

	private updateRenderedItem (item: LibraryCollectionItem): void {
		this.node.data = item;
		this.dataSource.updateItem(item.hash, item);
	}

	private isParentChildSync (item) {
		return item.parent_child_sync;
	}

	private getUserIds (): number[] {
		return this.dataSource.getUserIds();
	}
}
